import { api } from './api';

// Phase 2 API wrapper
export const mortgageApi = {
  getStages: () => api.get('/v2/mortgage/stages').then(r => r.data),
  setStages: (stages) => api.put('/v2/mortgage/stages', stages).then(r => r.data),
  listOpps: (params = {}) => api.get('/v2/mortgage/opportunities', { params }).then(r => r.data),
  getOpp: (id) => api.get(`/v2/mortgage/opportunities/${id}`).then(r => r.data),
  // Assignments on the card (ADR-0004 / ticket 69) — same shape as losApi's.
  listAssignments: (id) => api.get(`/v2/mortgage/opportunities/${id}/assignments`).then(r => r.data),
  addAssignment: (id, body) => api.post(`/v2/mortgage/opportunities/${id}/assignments`, body).then(r => r.data),
  removeAssignment: (id, userId, slot) => api.delete(`/v2/mortgage/opportunities/${id}/assignments/${userId}`, { params: slot ? { slot } : {} }).then(r => r.data),
  createOpp: (p) => api.post('/v2/mortgage/opportunities', p).then(r => r.data),
  updateOpp: (id, p) => api.patch(`/v2/mortgage/opportunities/${id}`, p).then(r => r.data),
  moveStage: (id, stage, notes) => api.post(`/v2/mortgage/opportunities/${id}/stage`, { stage, notes }).then(r => r.data),
  listLenders: () => api.get('/v2/mortgage/lenders').then(r => r.data),
  createLender: (p) => api.post('/v2/mortgage/lenders', p).then(r => r.data),
  updateLender: (id, p) => api.patch(`/v2/mortgage/lenders/${id}`, p).then(r => r.data),
  deleteLender: (id) => api.delete(`/v2/mortgage/lenders/${id}`).then(r => r.data),
  alerts: (days = 7) => api.get('/v2/mortgage/alerts', { params: { days } }).then(r => r.data),
  // Ticket 122 S5: GHL sync state for the board toolbar line.
  syncStatus: () => api.get('/v2/mortgage/sync-status').then(r => r.data),
};

// Phase 3 API wrapper
export const reApi = {
  getStages: (kind) => api.get('/v2/re/stages', { params: { kind } }).then(r => r.data),
  listOpps: (params = {}) => api.get('/v2/re/opportunities', { params }).then(r => r.data),
  getOpp: (id) => api.get(`/v2/re/opportunities/${id}`).then(r => r.data),
  listAssignments: (id) => api.get(`/v2/re/opportunities/${id}/assignments`).then(r => r.data),
  addAssignment: (id, body) => api.post(`/v2/re/opportunities/${id}/assignments`, body).then(r => r.data),
  removeAssignment: (id, userId, slot) => api.delete(`/v2/re/opportunities/${id}/assignments/${userId}`, { params: slot ? { slot } : {} }).then(r => r.data),
  createOpp: (p) => api.post('/v2/re/opportunities', p).then(r => r.data),
  updateOpp: (id, p) => api.patch(`/v2/re/opportunities/${id}`, p).then(r => r.data),
  moveStage: (id, stage, notes) => api.post(`/v2/re/opportunities/${id}/stage`, { stage, notes }).then(r => r.data),
  createTransactionFromOpp: (oppId, body = {}) => api.post(`/v2/re/opportunities/${oppId}/transaction`, body).then(r => r.data),
  addViewing: (id, p) => api.post(`/v2/re/opportunities/${id}/viewings`, p).then(r => r.data),
  addOffer: (id, p) => api.post(`/v2/re/opportunities/${id}/offers`, p).then(r => r.data),
  addOpenHouse: (id, p) => api.post(`/v2/re/opportunities/${id}/open-houses`, p).then(r => r.data),
  alerts: (days = 7) => api.get('/v2/re/alerts', { params: { days } }).then(r => r.data),
};

// Phase 4 API wrapper
export const automationApi = {
  listRecipes: () => api.get('/v2/automation/recipes').then(r => r.data),
  listWorkflows: (params = {}) => api.get('/v2/automation/workflows', { params }).then(r => r.data),
  createWorkflow: (p) => api.post('/v2/automation/workflows', p).then(r => r.data),
  createFromRecipe: (recipe_id) => api.post('/v2/automation/workflows/from-recipe', { recipe_id }).then(r => r.data),
  getWorkflow: (id) => api.get(`/v2/automation/workflows/${id}`).then(r => r.data),
  updateWorkflow: (id, p) => api.patch(`/v2/automation/workflows/${id}`, p).then(r => r.data),
  deleteWorkflow: (id) => api.delete(`/v2/automation/workflows/${id}`).then(r => r.data),
  pause: (id) => api.post(`/v2/automation/workflows/${id}/pause`).then(r => r.data),
  activate: (id) => api.post(`/v2/automation/workflows/${id}/activate`).then(r => r.data),
  duplicate: (id) => api.post(`/v2/automation/workflows/${id}/duplicate`).then(r => r.data),
  test: (id, payload) => api.post(`/v2/automation/workflows/${id}/test`, payload).then(r => r.data),
  listRuns: (params = {}) => api.get('/v2/automation/runs', { params }).then(r => r.data),
};
